import API from "../../api/api";
import Auth from "../../auth.js";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "react-router-dom";
import React, { Component } from "react";
import "../../styles/css/header/header.css";
// import Wrapper from '../Wrapper/Wrapper';
import Menu from "@material-ui/core/Menu";
import { withRouter } from "react-router-dom";
import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
// import Badge from '@material-ui/core/Badge';
import HomeIcon from "@material-ui/icons/Home";
import HeaderStyles from "../../styles/Header";
import Toolbar from "@material-ui/core/Toolbar";
// import MenuIcon from '@material-ui/icons/Menu';
import Collapse from "@material-ui/core/Collapse";
import MenuItem from "@material-ui/core/MenuItem";
import SearchIcon from "@material-ui/icons/Search";
import PersonIcon from "@material-ui/icons/Person";
import ReorderIcon from "@material-ui/icons/Reorder";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import LiveHelpIcon from "@material-ui/icons/LiveHelp";
import PersonPinIcon from "@material-ui/icons/PersonPin";
import DashboardIcon from "@material-ui/icons/Dashboard";
// import SettingsIcon from '@material-ui/icons/Settings';
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
// import AccountBoxIcon from '@material-ui/icons/AccountBox';
import OpenInBrowserIcon from "@material-ui/icons/OpenInBrowser";
// import NotificationsIcon from '@material-ui/icons/Notifications';
import SettingsApplicationsIcon from "@material-ui/icons/SettingsApplications";

const token = localStorage.getItem("token");
const userName = localStorage.getItem("userName");
const userId = localStorage.getItem("userId");
const userRole = localStorage.getItem("userRole");
const userRoleId = localStorage.getItem("userRoleId");
// const userRole = localStorage.getItem('userRole');
console.log(userRole);

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      searchExpanded: false,
      notificationDot: this.props.isNewNotification,
      token: localStorage.getItem("token"),
      screenWidth: "",
    };
    this.logout = this.logout.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.isNewNotification !== prevProps.isNewNotification) {
      this.setState({
        notificationDot: this.props.isNewNotification,
      });
    }
  }

  componentDidMount() {
    this.setState({ screenWidth: window.innerWidth });
  }

  handleSettingdToggle = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleCloseMenu = () => {
    this.setState({ anchorEl: null });
  };

  handleSearchExpandToggle = () => {
    this.setState({ searchExpanded: !this.state.searchExpanded });
  };

  handleDrawerToggle = () => {
    this.props.toggleDrawer();
    if (this.state.searchExpanded) this.handleSearchExpandToggle();
  };

  handleNotificationToggle = () => {
    this.props.toogleNotifications();
    if (this.state.searchExpanded) this.handleSearchExpandToggle();

    API.get("notification/update_user")
      .then(() => {
        this.setState({
          notificationDot: false,
        });
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  };

  mobileDashboard = () => {
    this.props.history.push("/");
  };
  mobileLanding = () => {
    this.props.history.push("/landing");
  };
  mobileBrowseJobs = () => {
    this.props.history.push("/browseguest/str");
  };
  mobileWhyUse = () => {
    this.props.history.push("/");
  };
  mobileLogin = () => {
    this.props.history.push("/signin");
  };

  logout() {
    API.post("logout")
      .then(() => {
        sessionStorage.clear();
        Auth.logout(() => {
          this.props.history.push("/signin");
        });
        localStorage.clear();
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  }

  render() {
    const { classes } = this.props;
    const { anchorEl, searchExpanded } = this.state;
    return (
      <AppBar position="static" className={classes.appBar}>
        <Toolbar className={`${classes.toolBar} parentDiv`}>
          <div className="leftDiv">
            {token && token.length > 0 ? (
              <Link to="/" className="headerLogoLink">
                <div className={`headerLogo`}>
                  <img
                    src="/static/images/titlesurvlogo.png"
                    alt="TitleServe"
                    className={classes.logo}
                  />
                </div>
              </Link>
            ) : (
              <a href="https://surveysource.com" className="headerLogoLink">
                <div className={`headerLogo`}>
                  <img
                    src="/static/images/titlesurvlogo.png"
                    alt="TitleServe"
                    className={classes.logo}
                  />
                </div>
              </a>
            )}

            <div className="headerMenus desktopDivFlex">
              <span>
                {token && token.length > 0 ? (
                  <div>
                    <Link className="nav-link-wrapper" to="/">
                      Dashboard
                    </Link>
                    {/* <Link
                        to={`/PropertyForm/${userId}`}
                    >
                      Elevation Certificate
                    </Link> */}

                    {userRole === "Surveyor" ? (
                      <Link to={`/Questionnaire/${userId}`}>
                        Elevation Certificate
                      </Link>
                    ) : null}
                  </div>
                ) : (
                  <Link to="/browseguest/str">Browse jobs</Link>
                )}
              </span>
              {/* <span>
                <Link to="">Why use Survey Source?</Link>
              </span> */}
            </div>
          </div>
          <div className="rightDiv">
            {/* <IconButton color="inherit" onClick={this.handleNotificationToggle}>
              {
                notificationDot ?
                  <Badge color="secondary" badgeContent="" className={classes.margin} variant="dot">
                    <NotificationsIcon />
                  </Badge>
                  :
                  <NotificationsIcon />
              }
            </IconButton> */}
            <div className="desktopDiv">
              <Link to={token && token.length > 0 ? "#" : "/signin"}>
                <div className="loginHead">
                  <IconButton
                    className="loginButton"
                    aria-label="User Settings"
                    aria-owns={anchorEl ? "user-menu" : null}
                    aria-haspopup="true"
                    color="primary"
                    onClick={this.handleSettingdToggle}
                  >
                    <PersonIcon />
                  </IconButton>
                  <div className="loginText desktopDiv">
                    {token && token.length > 0 ? (
                      <span>{userName}</span>
                    ) : (
                      <span>Login</span>
                    )}
                  </div>
                </div>
              </Link>
            </div>
            <div className="mobileDiv">
              <div className="loginHead">
                <IconButton
                  className="loginButton"
                  aria-label="User Settings"
                  aria-owns={anchorEl ? "user-menu" : null}
                  aria-haspopup="true"
                  color="primary"
                  onClick={this.handleSettingdToggle}
                >
                  <ReorderIcon />
                </IconButton>
              </div>
            </div>
            {token && token.length > 0 ? (
              <Menu
                id="user-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleCloseMenu}
              >
                <div className="mobileDiv removeFocus">
                  <MenuItem>
                    <ListItemIcon>
                      <PersonIcon />
                    </ListItemIcon>
                    <ListItemText inset primary={userName} />
                  </MenuItem>
                  <MenuItem onClick={this.mobileDashboard}>
                    <ListItemIcon>
                      <DashboardIcon />
                    </ListItemIcon>
                    <ListItemText inset primary="Dashboard" />
                  </MenuItem>
                  <MenuItem onClick={this.mobileWhyUse}>
                    <ListItemIcon>
                      <LiveHelpIcon />
                    </ListItemIcon>
                    <ListItemText inset primary="Why use TitleServ?" />
                  </MenuItem>
                </div>
                <MenuItem
                  onClick={() => this.props.history.push(`/Profile/${userId}`)}
                >
                  <ListItemIcon>
                    <PersonPinIcon />
                  </ListItemIcon>
                  <ListItemText inset primary="Profile" />
                </MenuItem>
                {/* <MenuItem
                  onClick={() =>
                    this.props.history.push(`/Questionnaire/${userId}`)
                  }
                >
                  <ListItemIcon>
                    <PersonPinIcon />
                  </ListItemIcon>
                  <ListItemText inset primary="Elevation Certificate" />
                </MenuItem> */}
                {/* <MenuItem onClick={() => this.props.history.push(`/Settings`)}>
                  <ListItemIcon>
                    <SettingsApplicationsIcon />
                  </ListItemIcon>
                  <ListItemText inset primary="Settings" />
                </MenuItem> */}
                <MenuItem onClick={this.logout}>
                  <ListItemIcon>
                    <ExitToAppIcon />
                  </ListItemIcon>
                  <ListItemText inset primary="Sign out" />
                </MenuItem>
              </Menu>
            ) : this.state.screenWidth < 768 ? (
              <Menu
                id="user-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleCloseMenu}
              >
                <div className="mobileDiv removeFocus">
                  <MenuItem onClick={this.mobileLogin}>
                    <ListItemIcon>
                      <ExitToAppIcon />
                    </ListItemIcon>
                    <ListItemText inset primary="Login" />
                  </MenuItem>
                  <MenuItem onClick={this.mobileLanding}>
                    <ListItemIcon>
                      <HomeIcon />
                    </ListItemIcon>
                    <ListItemText inset primary="Home" />
                  </MenuItem>
                  <MenuItem onClick={this.mobileBrowseJobs}>
                    <ListItemIcon>
                      <OpenInBrowserIcon />
                    </ListItemIcon>
                    <ListItemText inset primary="Browse jobs" />
                  </MenuItem>

                  <MenuItem onClick={this.mobileWhyUse}>
                    <ListItemIcon>
                      <LiveHelpIcon />
                    </ListItemIcon>
                    <ListItemText inset primary="Why use Survey Source?" />
                  </MenuItem>
                </div>
              </Menu>
            ) : null}
          </div>
        </Toolbar>
        <Hidden smUp>
          <Collapse in={searchExpanded} timeout="auto" unmountOnExit>
            <Toolbar className={classes.toolBar}>
              <div className={classes.searchWrapper}>
                <form className={classNames(classes.searchForm, "mr-0")}>
                  <IconButton
                    aria-label="Search"
                    className={classes.searchIcon}
                  >
                    <SearchIcon />
                  </IconButton>
                  <input
                    className={classes.searchInput}
                    type="text"
                    placeholder="Search"
                    autoFocus="true"
                  />
                </form>
              </div>
            </Toolbar>
          </Collapse>
        </Hidden>
      </AppBar>
    );
  }
}

Header.prototypes = {
  classes: PropTypes.object.isRequired,
  logo: PropTypes.string,
  logoAltText: PropTypes.string,
};

export default withRouter(withStyles(HeaderStyles)(Header));



// WEBPACK FOOTER //
// ./src/components/Header/Header.js